import React from "react";
import PropTypes from "prop-types";
import Alert from "react-bootstrap/Alert";
import Image from "react-bootstrap/Image";
import styled from "styled-components";
import { altText } from "../../lib/constants";
import { useHistory } from "react-router-dom";
import { isLogged } from "../utils/auth";
import { buttonText } from "../../lib/constants";
import Button from "react-bootstrap/Button";

const TopBarAlert = styled(Alert)`
  display: flex;
  align-items: center;
  background-color: #04547d;
  color: white;
  border: none;
  border-radius: 0;
  min-height: 4rem;

  .center-content {
    display: flex;
    align-items: center;
    gap: 10px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .right-content {
    margin-left: auto;
    margin-right: 4%;
  }
 
  p {
    margin-bottom: 0;
    margin-left: 10px;
    font-size: 0.8rem;
  }
    
  @media (max-width: 768px) {
    .center-content {
      position: static;
      transform: none;
      left: auto;
      
      h6 {
        font-size: 0.8rem;
      }
    }
    

  }

  @media (max-width: 480px) {
    .center-content {
      h6 {
        font-size: 0.75rem;
      }
    }
`;

export const TopBar = ({ content }) => {
  const userIsLogged = isLogged();
  const history = useHistory();
  const handleLogout = () => {
    history.push('/logout');
  };
  
  return (
    <TopBarAlert variant="primary">
      <div className="center-content">
        <Image
          src="/checkout/icon.png"
          width={35}
          alt={altText.top_bar}/>
        <h6>{content}</h6>
      </div>
      
      {userIsLogged && (
        <div className="right-content">
          <Button 
            variant="outline-light" 
            size="sm" 
            onClick={handleLogout}
          >
            {buttonText.logout}
          </Button>
        </div>
      )}
    </TopBarAlert>
  );
};

TopBar.propTypes = {
  content: PropTypes.string,
};